<template>
  <article class="us" id="us" >
    <div class="us__filter"></div>
    <section
      class="us__bar_side">
      <div
        v-for="(section, index) in data"
        v-html="section.title"
        @click="selected = index"
        :class="{'active': index == selected}"></div>
    </section>
    <section
      class="us__content"
      :class="{'long' : data[selected].long}">
      <p v-html="data[selected].text"></p>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      selected: 0,
      data:[
        {
          title: "Quienes<br>Somos",
          text: "I.P.P S.A.S. es una empresa Colombiana constituida desde el año 2010, "+
                "por iniciativa de ingenieros especializados en procesos y con amplia "+
                "experiencia en la formulación, ejecución y seguimiento de proyectos según los mejores estándares"+
                " internacionales. I.P.P se especializa en el manejo, procesamiento y disposición de "+
                "fluidos buscando hacer eficientes las técnicas en donde estos participan "+
                "para generar optimizaciones que beneficien a sus clientes",
          long: false
        },
        {
          title: "Misión",
          text: "Somos una compañía comprometida con el cumplimiento de los estándares más rigurosos en temas de alcance, costos y calidad en los proyectos que dirigimos, Somo reconocidos como un referente para la prestación de servicios en el área de ingeniería de procesos.",
          long: false
        },
        {
          title: "Visión",
          text: "Ser una de las empresas de consultoría y servicios más reconocida al nivel nacional e internacional por su calidad en el trabajo continuo con los clientes, a través de la experiencia, innovación y aplicación de tecnologías modernas para la optimización y el incremento de la competitividad de la industria.",
          long: false
        },
        {
          title: "Filosofia<br>de trabajo",
          text: "Ingeniería Proceso y Proyectos I.P.P enfoca su actuación alineada a sus valores y principios como:<br>"+
                "<ul>"+
                  "<li>&#8226; Pluralidad, e igualdad de género y cultura.</li>"+
                  "<li>&#8226; Honestidad y ética en los negocios.</li>"+
                  "<li>&#8226; Principios con Seguridad Industrial, ambiental y de las personas.</li>"+
                  "<li>&#8226; Trabajo en equipo y sinergia con los clientes y proveedores.</li>"+
                  "<li>&#8226; Cumplimiento del marco legislativo HSEQ vigente de la industria.</li>"+
                  "<li>&#8226; Comunicación franca con los clientes.</li>"+
                  "<li>&#8226; Relación Gana-Gana con sus clientes.</li>"+
                "</ul><br>"+
                "Ingeniería Proceso y Proyectos I.P.P enfoca su conocimiento en las siguientes áreas:<br>"+
                "<ul>"+
                  "<li>&#8226; Formulación ejecución e interventoría de proyectos según metodologías internacionales como IPA y PMI, marcas registradas.</li>"+
                  "<li>&#8226; Análisis, monitoreo y asesoría en el procesamiento de hidrocarburos.</li>"+
                  "<li>&#8226; Tratamiento y monitoreo de aguas municipales e industriales.</li>"+
                  "<li>&#8226; Automatización de procesos industriales.</li>"+
                  "<li>&#8226; Optimización de procesos industriales con enfoque en la eficiencia energética.</li>"+
                "</ul><br>"+
                "I.P.P S.A.S Busca brindar a sus clientes el acompañamiento especializado en ingeniería de fluidos y procesos con altos estándares de QAQC para alcanzar la eficiencia y competitividad requerida por los mercados modernos.",
          long: true
        }
      ]
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/Us.vue